<template>
  <category-explorer
    class="pt-0 m:-mt-2 l:pt-2 pb-2"
    :categories="categories"
    :show-trial-end-date="false"
    :show-scroll-up="false"
    :show-start-trial="false"
    :clickable-books="false"
    :are-books-linked="false"
    :show-books-from-other-categories="false"
    :centered="false"
    :collapsed-categories-on-mobile="true"
    background-color="white"
  >
    <template v-slot:header="headerProps">
      <b-headline type="h3" typography="h3" class="category-explorer__headline text-h35 m:text-h3 mb-2">
        {{ headline }}
      </b-headline>

      <b-subheadline class="category-explorer__subheadline mb-6 m:mb-8">
        {{ $t("subheadline", { totalCategories: headerProps.totalCategories }) }}
      </b-subheadline>
    </template>

    <template v-slot:category-header="categoryHeaderProps">
      <b-headline
        type="h3"
        typography="h3"
        v-html="$t('categoryHeadline', { categoryName: categoryHeaderProps.title })"
        class="category-book-slider__headline text-h35 m:text-h3 mb-2"
      />

      <b-subheadline class="category-book-slider__subheadline mb-6 m:mb-8">
        {{ $t("categorySubheadline") }}
      </b-subheadline>
    </template>
  </category-explorer>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import CategoryExplorer from "@/component-library/category-explorer"
import BSubheadline from "@/component-library/b-subheadline"

export default {
  name: "OrganisationsCategoryExplorer",
  components: {
    BHeadline,
    BSubheadline,
    CategoryExplorer
  },
  props: {
    categories: {
      type: Array,
      default: () => [],
      required: true
    },
    header: {
      type: String,
      default: ""
    },
    inviterName: {
      type: String,
      default: ""
    }
  },
  computed: {
    headline() {
      return this.inviterName ? this.$t("personalisedHeadline", { inviterName: this.inviterName }) : this.$t("headline")
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Find what you are interested in",
        personalisedHeadline: "Discover titles you like or want to share with {inviterName}.",
        subheadline: "With {totalCategories} categories available, find the right tiles for you",
        categoryHeadline: "Most popular in <mark>{categoryName}</mark>",
        categorySubheadline: "Here’s what’s popular with the Blinkist community"
      },
      de: {
        headline: "Was interessiert dich?",
        personalisedHeadline: "Entdecke spannende Titel, die du mit {inviterName} teilen kannst",
        subheadline: "Bei {totalCategories} Kategorien geht euch der Gesprächsstoff nie aus.",
        categoryHeadline: "Beliebt in <mark>{categoryName}</mark>",
        categorySubheadline: "Das hört und liest die Blinkist Community"
      }
    }
  }
}
</script>
